module.exports = __webpack_public_path__ + "img/icon-point.79cf4930.svg";